//enquire form 
jQuery(function($){
  var info_to_be_sent = $('.product-info-to-be-sent').html();
  $('.enquire_class').find('.hidden-product-info').val(''+info_to_be_sent);
  
//   $('.hidden-product-info').val(''+info_to_be_sent);
  console.log($('.enquire_class').find('.hidden-product-info').val(''+info_to_be_sent));
  //console.log($('.appointment_class').find('.hidden-product-info').val(''+info_to_be_sent));
  
  if(window.location.href.indexOf('contact_posted=true') > -1){
    //$('.enquire_now').trigger('click');
    $('.enquire_success').trigger('click');
    var newUrl = window.location.href.replace('?contact_posted=true', '');
    $("#enquire_success .fancybox-close-small").on("click", function(){
      console.log(newUrl);
      window.history.pushState({path:newUrl},'',newUrl);
    });

  }
});
